<template>
    <div class="product-item" loading="loading">
        {{model.partnerDealId}}
        <section class="product-item-content">
            <v-tabs @tab-click="tabChange" class="fixed-header-content" :active-name="activeIndex" ref="tabs">
                <v-tab-pane label="产品基本信息">
                    <span slot="title" v-show="showErrorOnTabs && errors[0] && errors[0].items && errors[0].items['tab1'] && errors[0].items['tab1'].length > 0" class="icon-info help-icon tab-error-icon"></span>
                    <info :model.sync="model" @updateMsRatio="updateMsRatio" :errors.sync="errors" :validate.sync="tabs[0].status" :mode="mode" :extra="extra" :loaded="modelLoaded" ref='info'></info>
                </v-tab-pane>
                <v-tab-pane label="购买使用说明">
                    <span slot="title" v-show="showErrorOnTabs && errors[0] && errors[0].items && errors[0].items['tab2'] && errors[0].items['tab2'].length > 0" class="icon-info help-icon tab-error-icon"></span>
                    <instruction :model.sync="model" :validate.sync="tabs[1].status" :errors.sync="errors" :mode="mode"  :extra="extra"></instruction>
                </v-tab-pane>
                <v-tab-pane label="价格/库存/有效期">
                    <span slot="title" v-show="showErrorOnTabs && errors[0] && errors[0].items && errors[0].items['tab3'] && errors[0].items['tab3'].length > 0" class="icon-info help-icon tab-error-icon"></span>
                    <price ref="price" :model.sync="model" :errors.sync="errors" :extra="extra" :mode="mode"></price>
                </v-tab-pane>
            </v-tabs>
        </section>
        <div class="row button-area" v-if="!loading">
            <div class="col-sm-4 col-sm-offset-2">
                <v-button :disabled="activeIndex == 1" v-show="activeIndex > 1" content="上一步" @click="prevStep" type="primary"></v-button>
                <v-button :disabled="mode == 'readonly'" content="保存" @click="saveModel" v-show="mode != 'new' || activeIndex== tabs.length" type="primary"></v-button>
                <v-button :disabled="mode == 'readonly'" content="保存并提交审核" @click="saveAndCheck" v-show="mode != 'new' || activeIndex== tabs.length" type="warning"></v-button>
                <v-button :disabled="activeIndex == tabs.length" v-show="activeIndex < tabs.length" content="下一步" @click="nextStep" type="primary"></v-button>
            </div>
        </div>
        <preview :url="previewUrl" class="preview-product" v-if="mode != 'readonly'">
            <button @click="previewShowTrigger = false" v-if="previewShowTrigger" class="btn btn-sm btn-warning">X</button>
            <button @click="saveAndPreview()" v-if="previewShowTrigger" class="btn btn-sm btn-warning">更新手机并预览产品</button>
            <button @click="saveAndPreview()" v-if="!previewShowTrigger" class="btn btn-sm btn-warning">保存并手机预览产品</button>
        </preview>
        <te-hui-apply :options="teHuiOption" :show.sync="teHuiShow"></te-hui-apply>
    </div>
</template>
<style rel="stylesheet/css" lang="postcss" type="text/postcss">
    .fixed-header-content ul.nav-tabs {
        position: fixed;
        left: 20px;
        right: 20px;
        top: 0px;
        background: #FFF;
        padding-top: 20px;
        margin: 0;
        z-index: 100;
    }
</style>
<style rel="stylesheet/css" lang="postcss" scoped type="text/postcss">
    .product-item{
        position: relative;
        &-content{
             min-height: 500px;
             margin-top: 50px;
        }
    }
    .button-area{
        border-top: solid 1px #ccc;
        padding: 20px 0;
    }
    .tab-error-icon{
        position: absolute;
        right: 5px;
        top: 5px;
        /*transform: translate(0, -50%);*/
    }
    .preview-product{
        position: fixed;
        right: 20px;
        top: 25px;
        z-index: 101;
    }

    .bubble{
        position: absolute;
        background: #f60;
        color: #fff;
        top: -10px;
        right: -5px;
        z-index: 1;
        width: 22px;
        height: 22px;
        display: block;
        text-align: center;
        border-radius: 22px;
        line-height: 22px;
    }
</style>
<script>
    import Vue from 'vue'
    import TicketDraft from 'helpers/ticketDraft'
    import { mapActions, mapGetters } from 'vuex';
    import Instruction from './Instruction.vue';
    import Info from './Info.vue';
    import Price from './Price.vue';
    import Preview from 'components/product/preview.vue';
    import TeHuiApply from 'components/product/teHuiApply.vue';
    import { get, create, audit, getMsRatio, update, cancelAudit, tehuiCheck } from 'api/ticket';
    import CustomMessageBox from 'components/messagebox-custom/message.box.js';
    import getDefaultModel from '../common/defaultModel';
    CustomMessageBox(Vue)
    let history = window.history;

    export default {
        components: {
            Instruction,
            Info,
            Price,
            Preview,
            TeHuiApply
        },
        data () {
            return {
                entryTime: '',
                teHuiOption: null,
                teHuiShow: false,
                previewShowTrigger: '',
                loading: false,
                id: '',
                errors: [],
                model: {},
                activeIndex: '1',
                tabs: [{
                    name: 'basicInfoForm',
                    status: false
                }, {
                    name: 'orderInfoForm',
                    status: false
                }, {
                    name: 'priceStockForm',
                    status: false
                }],
                mode: 'edit',
                showErrorOnTabs: false,
                userinfo: false,
                ls: false, //localstorage
                modelLoaded: false
            }
        },
        computed: {
            ...mapGetters(['account']),
            // 获取其他非deal的信息
            extra () {
                const DirectDealIDs = [
                    2, // 直连V2
                    4, // 直连V1
                    5, // 手工上单转直连
                ]
                return {
                    partnerDealId: this.model.partnerDealId,
                    // 是否是直签商家， true是，false为三方
                    isDirect: this.account.directSign > 0,
                    // 是否直连产品
                    isDirectDeal: (this.model.sourceType && DirectDealIDs.indexOf(this.model.sourceType) !== -1) || this.$route.query.isDirectDeal==='true',
                    // 是否是bd上单模板
                    isBD: this.$route.meta.isMis,
                    contractNum: this.$route.query.contractNum || this.model.contractNum,
                    contractId: this.$route.query.contractId || this.model.contractId,
                    supplierId: this.$route.query.supplierId || this.account.supplierId,
                    isNew: (!this.id || this.mode === 'copy') && !this.model.mtDealId
                };
            },
            previewUrl () {
                if (this.mode === 'edit' && this.previewShowTrigger) {
                    return `https://i.meituan.com/awp/h5/lvyou/deal/ticket/detail/index.html?dealId=${this.id}&type=offline&time=${this.previewShowTrigger}`;
                } else {
                    return '';
                }
            }
        },
        watch: {
            '$route': 'initProduct',
            activeIndex () {
                window.scrollTo && window.scrollTo(0, 0);
            },
            model: {
                handler: function (val, oldVal) {

                },
                deep: true
            }
        },
        methods: {
            ...mapActions(['login', 'getUser']),
            initProduct () {
                const id = this.$route.params.id;
                this.id = id;
                const isMis = this.$route.meta.isMis;
                let supportModes = ['new', 'edit', 'copy', 'readonly'];
                if (supportModes.indexOf(this.$route.query.mode) > -1) {
                    this.mode = this.$route.query.mode;
                } else {
                    this.mode = id ? 'edit' : 'new';
                }

                if (id) {
                    this.loading = true;
                    get(id).then((json) => {
                        this.loading = false;
                        this.model = getDefaultModel(this.extra.isDirectDeal, this.mode === 'copy', json.data);
                        this.checkDataStatus(this.model);
                        this.updateMsRatio();
                        if (this.mode !== 'new') {
                            this.checkDraft()
                        }
                        // 出现垃圾数据，直连出票方式写死成3
                        if (this.extra.isDirectDeal) {
                            this.model.generateTicketMethod = 3
                        }
                    }).catch((response) => {
                        this.loading = false;
                        this.$message.error(response && response.message);
                        this.model = getDefaultModel(this.extra.isDirectDeal, this.mode === 'copy',);
                    })
                    if (!isMis) {
                        const supplierId = this.$route.query.supplierId;
                        if (supplierId) {

                        }
                    }
                } else {
                    this.mode = 'new';
                    this.model = getDefaultModel(this.extra.isDirectDeal, this.mode === 'copy',);
                }
            },
            updateMsRatio () {
                if (this.model.ticketCategory.poi) {
                    let mdcPoiIds = [];
                    this.model.ticketCategory.poi.map((item, index) => {
                        mdcPoiIds.push(item.mdcPoiId);
                        return item;
                    });
                    this.model.mdcPoiIds = mdcPoiIds.join(',')
                } else {
                    this.model.ticketCategory.poi = [];
                }
                if (this.model.mdcPoiIds && this.model.mtCategory) {
                    getMsRatio(this.model.mdcPoiIds, this.model.mtCategory, this.extra.supplierId)
                        .then((result) => {
                            if (result && result.data) {
                                let data = result.data;
                                this.model.baseMsRatioSnapshot = data.maxMsRatio;
                                this.model.maxMsRatioProvinceName = data.maxMsRatioProvinceName;
                                this.model.provinceLocationIdsSnapshot = data.provinceLocationIdsSnapshot;
                            }
                        });
                } else {
                    this.model.baseMsRatioSnapshot = 0;
                    this.model.maxMsRatioProvinceName = '';
                    this.model.provinceLocationIdsSnapshot = [];
                }
            },
            tabChange (tab) {
                let lastActiveIndex = this.activeIndex;
                this.activeIndex = tab.key;
                // 剧场票只能BD查看
                if (!this.extra.isBD  && tab.key === '3' && this.model.IAmTheatre) {
                    this.$message.info('剧场票场次及席位信息，请联系您的BD进行查看和修改；');
                    this.$nextTick(
                        () => {
                            this.activeIndex = lastActiveIndex;
                        }
                    );
                    return;
                }
            },
            prevStep () {
                let current = parseInt(this.activeIndex);
                if (current === 1) {
                    return;
                }
                let index = current - 1;
                this.activeIndex = index.toString();
            },
            nextStep() {
                let current = parseInt(this.activeIndex)
                console.log(this.errors[0])
                if (this.errors[0].items && this.errors[0].items['tab'+current] && this.errors[0].items['tab'+current].length > 0) {
                    this.errors[0].showAllError('tab'+current)
                    return
                }

                if (this.tabs && current === this.tabs.length) {
                    return;
                }
                let index = current + 1;
                // 剧场票只能BD查看
                if (!this.extra.isBD  && index === 3 && this.model.IAmTheatre) {
                    this.$message.info('剧场票场次及席位信息，请联系您的BD进行查看和修改；');
                    return;
                }
                this.activeIndex = index.toString();
            },
            checkDataStatus (data) {
                if (data.checkStatus === 0 || data.msRatioCheckStatus === 0) {
                    this.mode = 'readonly'
                    this.$msgbox({
                        title: '撤销审核提示',
                        message: '您的deal正在审核，确认要撤销审核吗？撤销审核后您可以编辑您的产品，否则您只能查看产品',
                        confirmButtonText: '撤销',
                        cancelButtonText: '取消',
                    }).then(() => {
                        cancelAudit(this.id)
                            .then(() => {
                                this.$message.success('撤销审核成功');
                                this.mode = 'edit';
                            })
                            .catch((response) => {
                                this.$message.error(response.message || '撤销审核失败');
                            })
                    }).catch(() => {
                        // window.close();
                    })
                } else if (data.checkStatus === 4) {
                    this.mode = 'readonly'
                    this.$message.error('您的deal已被设为黑名单，无法编辑和提交审核。')
                }
            },
            prepareData (model) {
                let data = JSON.parse(JSON.stringify(model))
                if (parseInt(data.scheduleOfflineType, 10) === 1) {
                    data.scheduleOfflineTime = null;
                }
                if (!data.includeItems || (data.includeItems && data.includeItems.length <= 1)) {
                    data.isAllAvailable = undefined;
                    data.availableCount = undefined;
                }
                if (data.useDateMode == 1 && data.stockType === 1) {
                    data.dayPriceStockRules.forEach((item) => {
                        item.stock = -1;
                    });
                }
                for (let crowd of data.ticketPoiDiscounts) {
                    if (!crowd.ticketDiscountList || (crowd.ticketDiscountList.length === 1 && crowd.ticketDiscountList[0].crowd === null)) {
                        crowd.ticketDiscountList = null
                    }
                }
                if (parseInt(data.useDateMode, 10) == 1 && this.extra.isDirectDeal && parseInt(data.refundType, 10) === 4 && !this.model.IAmTheatre) {
                    data.stairsRefund = true
                    // 当阶梯退款只有一条，且退款为无限制的时候，使用外面的退款规则
                    // 阶梯退款不应该存在无限制，以防万一还是遍历所有数据
                    let foundTimeTypeZero = false
                    for (let rule of data.refundStairsRules) {
                        if (parseInt(rule.refundTimeType, 10) === 0) {
                            foundTimeTypeZero = true
                            break
                        }
                    }
                    // 有0 或者只有一条，不使用阶梯数据
                    if (foundTimeTypeZero || data.refundStairsRules.length === 1) {
                        const firstStair = data.refundStairsRules[0]
                        data.refundFee = firstStair.refundFee
                        data.refundFeeMode = firstStair.refundFeeMode
                        data.refundTimeType = firstStair.refundTimeType
                        if (data.refundTimeType > 0) {
                            data.refundLimitDays = firstStair.aheadDays;
                            data.refundLimitHours = firstStair.hours;
                            data.refundLimitMinutes = firstStair.minutes;
                        }

                        data.stairsRefund = false
                    }
                } else {
                    data.stairsRefund = false
                }
                // 退款数据清洗，先放在这，之后移到组件中
                if (this.extra.isDirectDeal) {
                    if (data.refundType === 1) {
                        if (data.useDateMode >= 3 && !data.canRefundCurrentDate) {
                            data.canRefundCurrentDate = true;
                        }
                    } else {
                        let refundAfterCount = 0;
                        for (let rule of data.refundStairsRules)  {
                            if (rule.refundTimeType === 3) { // eslint-disable-line
                                refundAfterCount++;
                            }
                        }
                        if (refundAfterCount) {
                            if (data.useDateMode >= 3 && !data.canRefundCurrentDate) {
                                data.canRefundCurrentDate = true;
                            }
                        } else {
                            data.canRefundCurrentDate = true;
                        }
                    }
                    data.canRefundCurrentDate = data.canRefundCurrentDate.toString()
                }
                // 所有直连，sourcetype改成5
                if (this.extra.isDirectDeal) {
                    data.sourceType = 5;
                    if (this.model.IAmTheatre) {
                        data.needSpecialAuthFile = false;
                    }
                }
                // 保存的时候以防万一，再处理一次垃圾数据
                if (this.extra.isDirectDeal) {
                    data.generateTicketMethod = 3
                }
                return data;
            },
            doSave() {
                let data = this.prepareData(this.model)
                if (this.mode === 'edit') {
                    let id = this.model.id || this.id;
                    return update(id, data)
                        .then(() => {
                            return id;
                        }, (result) => {
                            if (result.status === 9) {
                                result.message = '保存失败';
                            }
                            throw result;
                        });
                }
                return create(data)
                    .then((response) => {
                        let dealId =  response.data && response.data.dealId || response.data
                        this.id = dealId;
                        return dealId;
                    }, (result) => {
                        if (result.status === 9) {
                            this.mode = 'edit';
                            this.id = result.data;
                            this.model.id = this.id;
                            result.message = '保存失败';
                        }
                        throw result;
                    });
            },

            saveModel(from = '') {
                if (this.doHaveErrors()) {
                    return
                }

                // 暂时先复制一份，之后优化
                if (this.hasProtocolButNotUsed()) {
                    const that = this
                    this.$confirm({
                        title: '提示',
                        message: '该供应商有签订返佣/包票补充协议，但是该deal并没有关联其补充协议，确定不关联吗？',
                        confirmButtonText:'去关联',
                        cancelButtonText:'不关联，继续保存'
                    }).then(function (data) {
                        that.$refs.info.$refs.supplierProtocol.connectProtocol = true
                        that.$refs.info.$refs.supplierProtocol.changeConnect()
                        that.activeIndex = '1'
                    }, function (err) {
                        return that.doSave()
                            .then((id) => {
                                if (history && history.pushState) {
                                    if (that.extra.isBD) {
                                        let state = that.$router.resolve({name: that.$route.name, query: { mode:'edit', supplierId:that.extra.supplierId}, params: {id: id}});
                                        history.pushState(null, 'notp', state.href);
                                    } else {
                                        let state = that.$router.resolve({name: that.$route.name, query: { mode:'edit'}, params: {id: id}});
                                        history.pushState(null, 'notp', state.href);
                                    }
                                }
                                // 清空草稿
                                const ls = that.getTicketDraftInstance()
                                if (ls) {
                                    ls.clearDraft()
                                }
                                if (from !== 'preview') {
                                    that.toListOrNot();
                                }
                                that.mode = 'edit';
                                return true;
                            }, (result) => {
                                let message;
                                if (result && result.message) {
                                    message = result.message || '保存失败, 网络错误';
                                } else {
                                    message = '保存失败, 网络错误';
                                }
                                that.$notify({
                                    title: '提示',
                                    message: message,
                                    type: 'error'
                                });
                                // 协议绑定失败
                                if (result.status === 10) {
                                    that.protocolFailed(result)
                                }
                                return false;
                            })
                    });
                } else {
                    return this.doSave()
                        .then((id) => {
                            // this.$notify({
                            //    title: '提示',
                            //    message: '保存成功',
                            //    type: 'success'
                            // })
                            // console.log(id);
                            if (this.mode !== 'edit') {
                                let isCopy = this.mode === 'copy';
                                let endTime = (new Date()).getTime();
                                let actString = `上报创建源${isCopy ? 'copydeal' : 'newcreate'}`;
                                if (window.Analytics){
                                    window.Analytics('event', {   // eslint-disable-line
                                        nm: 'mge',
                                        val: {
                                            cid: 'MTP上单成功页',
                                            act: actString,
                                            lab: {
                                                'start': this.entryTime,
                                                'end': endTime
                                            },
                                            val: id
                                        }});
                                }
                            }
                            if (history && history.pushState) {
                                if (this.extra.isBD) {
                                    let state = this.$router.resolve({name: this.$route.name, query: { mode:'edit', supplierId:this.extra.supplierId}, params: {id: id}});
                                    history.pushState(null, 'notp', state.href);
                                } else {
                                    let state = this.$router.resolve({name: this.$route.name, query: { mode:'edit'}, params: {id: id}});
                                    history.pushState(null, 'notp', state.href);
                                }
                            }
                            // 清空草稿
                            const ls = this.getTicketDraftInstance()
                            if (ls) {
                                ls.clearDraft()
                            }
                            if (from !== 'preview') {
                                this.toListOrNot();
                            }
                            this.mode = 'edit';
                            return true;
                        }, (result) => {
                            let message;
                            if (result && result.message) {
                                message = result.message || '保存失败, 网络错误';
                            } else {
                                message = '保存失败, 网络错误';
                            }
                            // 协议绑定失败
                            if (result.status === 10) {
                                this.protocolFailed(result)
                            } else {
                                this.$notify({
                                    title: '提示',
                                    message: message,
                                    type: 'error'
                                });
                            }
                            return false;
                        })
                }
            },
            // 保存协议是在上单成功之后，为了防止过多的脏数据，如果是协议保存失败，则是变成编辑状态
            protocolFailed (result) {
                try {

                    let message = (result && result.message) ? result.message : '关联失败'

                    message = message.replace(/\n/g, '<br>');

                    this.$alert_html({
                        title: '提示',
                        message: message,
                        showCancelButton: false,
                        closeOnClickModal: false,
                        confirmButtonText: '关闭'
                    });
                    this.activeIndex = '1'
                    this.mode = 'edit'
                    this.model.id = this.id = result.data.dealId;
                    if (history && history.pushState) {
                        let state = this.$router.resolve({name: this.$route.name, query: { mode:'edit', supplierId:this.extra.supplierId}, params: {id: result.data.dealId}});
                        history.pushState(null, 'notp', state.href);
                    }
                    // 清空草稿
                    const ls = this.getTicketDraftInstance()
                    if (ls) {
                        ls.clearDraft()
                    }
                    if (from !== 'preview') {
                        this.toListOrNot();
                    }
                    this.mode = 'edit';
                } catch (e) {
                    console.log(e.message)
                }
            },
            saveAndPreview () {
                let savePromise=this.saveModel('preview');
                if(savePromise && savePromise.then) {
                   savePromise.then((success) => {
                        if (success) {
                            this.$message({
                                showClose: true,
                                message: '保存成功',
                                type: 'success',
                                duration: 2000
                            });
                            this.previewShowTrigger = new Date().getTime();
                        }
                    });
                }
            },
            saveAndCheck() {
                if (this.doHaveErrors()) {
                    return
                }
                this.tabs.forEach((tab) => {
                    tab.status = true;
                });
                if (this.hasProtocolButNotUsed()) {
                    const that = this
                    this.$confirm({
                        title: '提示',
                        message: '该供应商有签订返佣/包票补充协议，但是该deal并没有关联其补充协议，确定不关联吗？',
                        confirmButtonText:'去关联',
                        cancelButtonText:'不关联，继续保存'
                    }).then(function (data) {
                        that.$refs.info.$refs.supplierProtocol.connectProtocol = true
                        that.$refs.info.$refs.supplierProtocol.changeConnect()
                        that.activeIndex = '1'
                    }, function (err) {
                        that.doSave()
                            .then((id) => {
                                if (parseInt(id) > 0) {
                                    audit(id)
                                        .then(() => {
                                            // 清空草稿
                                            const ls = that.getTicketDraftInstance()
                                            if (ls) {
                                                ls.clearDraft()
                                            }
                                            that.$msgbox({
                                                title: '提示',
                                                message: '提交审核成功',
                                                type: 'success',
                                                confirmButtonText: '返回产品列表',
                                                cancelButtonText: '确定'
                                            }).then(function () {
                                                window.close()
                                            });
                                            if (that.extra.isBD) {
                                                tehuiCheck(id).then((json) => {
                                                    if (json.data.isAllowApply) {
                                                        let data = json.data
                                                        data.dealId = id
                                                        that.teHuiShow = true
                                                        that.teHuiOption = data
                                                    }
                                                }).catch((resp) => {
                                                    // 特惠票检查失败
                                                })
                                            }
                                            if (history && history.pushState) {
                                                if (that.extra.isBD) {
                                                    let state = that.$router.resolve({name: that.$route.name, query: { mode:'edit', supplierId:that.extra.supplierId}, params: {id: id}});
                                                    history.pushState(null, 'notp', state.href);
                                                } else {
                                                    let state = that.$router.resolve({name: that.$route.name, query: { mode:'edit'}, params: {id: id}});
                                                    history.pushState(null, 'notp', state.href);
                                                }

                                            }
                                            that.mode = 'edit';
                                        }, (response) => {
                                            that.$notify({
                                                title: '提示',
                                                message: response && response.message,
                                                type: 'error'
                                            });
                                        });
                                }
                            }, (response) => {
                                that.$notify({
                                    title: '提示',
                                    message: response && response.message,
                                    type: 'error'
                                });
                            });
                    })
                } else {
                    this.doSave()
                        .then((id) => {
                            if (parseInt(id) > 0) {
                                audit(id)
                                    .then(() => {
                                        // 清空草稿
                                        const ls = this.getTicketDraftInstance()
                                        if (ls) {
                                            ls.clearDraft()
                                        }
                                        this.$msgbox({
                                            title: '提示',
                                            message: '提交审核成功',
                                            type: 'success',
                                            confirmButtonText: '返回产品列表',
                                            cancelButtonText: '确定'
                                        }).then(function () {
                                            window.close()
                                        });
                                        if (this.extra.isBD) {
                                            tehuiCheck(id).then((json) => {
                                                if (json.data.isAllowApply) {
                                                    let data = json.data
                                                    data.dealId = id
                                                    this.teHuiShow = true
                                                    this.teHuiOption = data
                                                }
                                            }).catch((resp) => {
                                                // 特惠票检查失败
                                            })
                                        }
                                        if (history && history.pushState) {
                                            if (this.extra.isBD) {
                                                let state = this.$router.resolve({name: this.$route.name, query: { mode:'edit', supplierId:this.extra.supplierId}, params: {id: id}});
                                                history.pushState(null, 'notp', state.href);
                                            } else {
                                                let state = this.$router.resolve({name: this.$route.name, query: { mode:'edit'}, params: {id: id}});
                                                history.pushState(null, 'notp', state.href);
                                            }
                                        }
                                        this.mode = 'edit';
                                    }, (response) => {
                                        this.$notify({
                                            title: '提示',
                                            message: response && response.message || '提交审核失败!',
                                            type: 'error'
                                        });
                                    });
                            }
                        }, (response) => {
                            // 协议绑定失败
                            if (response.status === 10) {
                                this.protocolFailed(response)
                            } else {
                                this.$notify({
                                    title: '提示',
                                    message: response && response.message,
                                    type: 'error'
                                });
                            }
                        });
                }
            },
            getTicketDraftInstance() {  // 获取票对象的单例
                // ls没有初始化 且 （（是BD 且 有合同id） 或 不是BD）则开始初始化ls
                if (!this.ls && ((this.extra.isBD && this.extra.contractId) || !this.extra.isBD)) {
                    this.ls = new TicketDraft(this.extra.isBD?this.extra.contractId:null)
                }
                return this.ls
            },
            saveDraft () {
                if (this.model.mtDealId || (!this.modelLoaded && this.model !== 'new')) return
                const ls = this.getTicketDraftInstance()
                if (ls) {
                    this.ls.draft(this.model)
                }
            },
            toListOrNot () {
                this.$msgbox({
                    title: '提示',
                    message: '保存成功',
                    confirmButtonText: '返回产品列表',
                    cancelButtonText: '取消',
                }).then(function () {
                    window.close()
                });
            },
            doHaveErrors() {
                let findError = false
                for (let i = 1; i < 4; i++) {
                    if (this.errors[0].items && this.errors[0].items['tab'+i] && this.errors[0].items['tab'+i].length > 0) {
                        this.errors[0].showAllError('tab'+i)
                        findError = true
                    }
                }

                if (findError) {
                    this.showErrorOnTabs = true
                    this.$notify({
                        title: '提示',
                        message: this.extra.isDirectDeal?'请您检查下橙色报警框，当前还有未填写的内容':'填写内容校验不通过，请详细检查每一项字段的输入值。',
                        type: 'error'
                    })
                    return true
                }
                if (!this.model.IAmTheatre) {
                    if (this.model.useDateMode === 0 && this.model.limitDayType === 1) {
                        this.$msgbox({
                            title: '提示',
                            message: '有效期模式的产品只可勾选“下单日限购”，请更改后再进行提交。',
                            type: 'error',
                            confirmButtonText: '确定',
                            showCancelButton: false
                        })
                        return true;
                    }
                }

                return false
            },
            checkDraft() {
                const ls = this.getTicketDraftInstance()
                if (this.extra.isNew && ls && ls.hasDraft()) {
                    const that = this
                    that.$confirm({
                        title: '草稿',
                        message: '您当前有草稿未保存，是否要继续编辑？',
                        confirmButtonText: ' 继续编辑',
                        cancelButtonText: '放弃草稿并重新创建',
                    }).then(function (data) {
                        //console.log(ls.useDraft())
                        that.model = ls.useDraft()
                        // 即使读取草稿，依然使用当前的一些数据
                        // 老直连的逻辑，只要是直连，全改成5。。。。。。
                        if (that.extra.isDirectDeal) {
                            that.model.sourceType = 5
                        }
                        //supplierId与get参数中不符的，恢复成get中的id
                        if (that.model.supplierId !== that.extra.supplierId) {
                            that.model.supplierId = that.extra.supplierId
                        }

                        that.$message({
                            message: '加载成功',
                            type: 'success'
                        });
                        that.modelLoaded = true
                    }, function (err) {
                        ls.clearDraft()
                        that.modelLoaded = true
                    });
                } else {
                    this.modelLoaded = true
                }
            },
            // 跨组件获取是否有协议
            hasProtocolButNotUsed() {
                // 跨组件获取是否有协议
                let yes = false
                try {
                    if (this.$refs.info.$refs.supplierProtocol.protocolTypeList.length > 0) {
                        yes = true
                        for (const key of Object.keys(this.model.supplierProtocolRule)) {
                            if (this.model.supplierProtocolRule[key].length > 0) {
                                yes = false
                                break
                            }
                        }
                    }
                } catch (e) {

                }
                return yes
            }
        },
        created () {
            // 组件创建完后获取数据，
            // 此时 data 已经被 observed 了
            window.router = this.$route;
            this.initProduct();
        },
        mounted () {
            // 如果是新建，监控model并存入草稿
            this.$watch(()=>!this.model.mtDealId?this.model:null, this.saveDraft, { deep: true})
            if (this.mode === 'new') {
                this.checkDraft()
            }
            this.entryTime = new Date().getTime();
        }
    }
</script>



// WEBPACK FOOTER //
// Main.vue?62a0f3ca